import React from 'react';

import { DynamicProductTable } from '../_dynamic';
import { ProductTableProps } from '../_dynamic/constants';

import { tableHead } from './constants';
import ProductItem from './item';

export const FixedIncomeTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      tableHeadItems={tableHead}
      tabletColumns={3}
      tabletRows={1}
      mobileFields={[
        { key: 'requestDate', label: 'Solicitação' },
        { key: 'movementType', label: 'Tipo' },
        { key: 'clientName', label: 'Cliente' },
        { key: 'issuerName', label: 'Emissor' },
        { key: 'productName', label: 'Ativo' },
        { key: 'rateDescription', label: 'Taxa' },
        { key: 'maturityDate', label: 'Vencimento' },
        { key: 'movementValue', label: 'Valor' },
        { key: 'status', label: 'Status' },
      ]}
    />
  );
};
